import { FC, useEffect } from 'react';
import { useAdvertContactsState } from '@edikk-edikk/ui';
import { useUserContext } from '@edikk-edikk/shared';
import { useMenuState, useButtonForAdvertContactsControl } from '#baseMenu/hooks';
import { ButtonAdvertContacts } from '#baseMenu/components/controls/middle-button/advert-contacts/ButtonAdvertContacts';
import { LinkToManage } from '#baseMenu/components/controls/middle-button/LinkToManage';
import { ReviewCheckToggle } from '#baseMenu/components/controls/middle-button/review-check-toggle';

const MiddleButton: FC = () => {
  const { isAuth } = useUserContext();
  const { isVisibleButtonForAdvertContacts } = useMenuState();
  const { show, hide } = useButtonForAdvertContactsControl();
  const { contactData } = useAdvertContactsState();

  useEffect(() => {
    if (contactData && !contactData.isEmpty) {
      show();
    } else {
      hide();
    }
  }, [contactData, hide, show]);

  if (isVisibleButtonForAdvertContacts) {
    return <ButtonAdvertContacts />;
  }

  if (isAuth) {
    return <LinkToManage />;
  }

  return <ReviewCheckToggle />;
};

export { MiddleButton };
